import { AWARD_PROGRESS } from "../../../../../common/enums/award-progress-codes";
import { IconShield, BADGE_TYPE, BADGE_SIZE } from "../../../../../common/icons/IconShield/IconShield";
import { AwardProgressBadge } from "../../../../../common/components/AwardProgressBadge/AwardProgressBadge";
import { useTranslation } from "react-i18next";
import defaultAwardContent from "../../../../../content/awardLabels";
import "./PinRequirement.scss";

interface Props {
  met: boolean;
  label: string;
  value?: string | number;
  statusTag?: AWARD_PROGRESS;
  status: AWARD_PROGRESS;
}

const getBadgeType = (met: boolean, status?: AWARD_PROGRESS): BADGE_TYPE => {
  if (met || status === AWARD_PROGRESS.ACHIEVED) {
    return BADGE_TYPE.EARNED;
  }
  if (status === AWARD_PROGRESS.NOT_TRACKING) {
    return BADGE_TYPE.NOT_EARNED;
  }
  return BADGE_TYPE.POTENTIAL;
};

export const PinRequirement = ({ met, label, value, statusTag, status }: Props) => {
  const badgeType = getBadgeType(met, status);
  const { t } = useTranslation(["awardLabels"]);
  const noDataLabel = t(
    "awardLabels.no-data-available",
    defaultAwardContent.awardLabels["no-data-available"] as string,
  );
  const isNoData = value === "--";
  const isLabelNoData = label === "--";

  return (
    <div className="pin-requirement">
      <div className="pin-requirement__icon">
        <IconShield type={badgeType} size={BADGE_SIZE.LARGE} />
      </div>

      <div className="pin-requirement__content">
        <span
          className="pin-requirement__label"
          {...(isLabelNoData ? { role: "text", "aria-label": noDataLabel } : {})}
        >
          {isLabelNoData ? <span aria-hidden="true">{label}</span> : label}
        </span>
        {statusTag ? (
          <AwardProgressBadge status={statusTag} hideIcon />
        ) : (
          value !== undefined && (
            <span className="pin-requirement__value" {...(isNoData ? { role: "text", "aria-label": noDataLabel } : {})}>
              {isNoData ? <span aria-hidden="true">{value}</span> : value}
            </span>
          )
        )}
      </div>
    </div>
  );
};
